import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '../../lib/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
  redirectToCheckout?: boolean;
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  withIcon = false,
  redirectToCheckout = true,
  children,
  className = '',
  onClick,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e);
    if (!redirectToCheckout) return;
    e.preventDefault();
    trackEvent('AddToCart', {
      content_name: 'The Menopause Belly Reset Protocol',
      content_ids: ['57793716683016'],
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
    // Small delay to ensure the pixel event is sent before navigation
    setTimeout(() => {
      window.location.href = 'https://digifactorymax.net/cart/57793716683016:1';
    }, 300);
  };
  const baseStyles = 'inline-flex items-center justify-center font-serif tracking-wide transition-all duration-300 ease-out rounded-sm cursor-pointer';
  const variants = {
    primary: 'bg-wellness-forest text-wellness-cream hover:bg-wellness-forest/90 shadow-sm hover:shadow-md',
    secondary: 'bg-wellness-gold text-white hover:bg-wellness-gold-dark shadow-sm hover:shadow-md',
    outline: 'border border-wellness-forest text-wellness-forest hover:bg-wellness-forest hover:text-wellness-cream'
  };
  const sizes = {
    sm: 'px-6 py-2.5 text-lg',
    md: 'px-8 py-3.5 text-xl',
    lg: 'px-10 py-4 text-2xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-170">
      {children}
      {withIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-171" />}
    </motion.button>;
};